import { Injector } from "@angular/core";
import { MeddraNode } from "../MeddraNode";
import { Art57Section } from "../../../Art57Section/Art57Section";
import { MeddraListView } from "../../../Data/MeddraData/MeddraListView";
import { SOCListView } from "../../../Data/MeddraData/SOCListView";
import { HLGTListView } from "../../../Data/MeddraData/HLGTListView";
import { LLTListView } from "../../../Data/MeddraData/LLTListVIew";
import { PTListView } from "../../../Data/MeddraData/PTListView";
import { TreeNodeMeddraLevelItem } from "./TreeNodeMeddraLevelItem";
import { environment } from "../../../../../../environments/environment";
import { HLTListView } from "../../../Data/MeddraData/HLTListView";
import { AuthService } from "../../../../service/auth-service/auth-service.service";
import { LocalStorageUtil } from "../../../LocalStorageUtil";
import { EntityEnum } from "../../EntityEnum";
import { BaseNode } from "../../BaseNode";


export class TreeNodeMeddraLevel extends MeddraNode {

    historyItems: string[] = [];
    criteria: string = "";
    showResults: boolean = false;

    constructor(injector: Injector, items: any[] | undefined, entityName: string, parent: BaseNode | undefined) {

        let view: any = null;
        let labelTemplate = 'TreeNodeMeddraLevel';
        switch (entityName) {
            case EntityEnum.soc:
                view = new SOCListView(items);
                labelTemplate = 'SOC Terms';
                break;
            case EntityEnum.hlgt:
                view = new HLGTListView(items);
                labelTemplate = 'HLGT Terms';
                break;
            case EntityEnum.hlt:
                view = new HLTListView(items);
                labelTemplate = 'HLT Terms';
                break;
            case EntityEnum.pt:
                view = new PTListView(items);
                labelTemplate = 'Preferred Terms';
                break;
            case EntityEnum.llt:
                view = new LLTListView(items);
                labelTemplate = 'Low Level Terms';
                break;
            default:
                view = new MeddraListView(items, [], []);
                break;
        }

        super(injector, view, labelTemplate, entityName, null, parent);
        let localStorageKey: string = `${injector.get(AuthService).getUser()}_${injector.get(AuthService).getOrganisation()}_${entityName}`;
        this.historyItems = LocalStorageUtil.getLocalStorageJson(localStorageKey);

    }

    addChild(item: any): MeddraNode | null {
        return null;
    }

    addChildren(items: any[]) { }

    removeChildren(items: any[]) { }

    addItem(item: any, node: TreeNodeMeddraLevelItem) {
        let returnedNode: any = node;
        let alreadyExistChildren: boolean = this.children!.some((child) => child.data.model.code === item.code);
        if (!alreadyExistChildren) {
            if (!this.data.model) {
                this.data.model = [];
            }
            this.children!.push(node);
        } else {
            returnedNode = this.children!.find((child) => child.data.model.code === item.code);
            this.ioc!.get(Art57Section).showTooltipMessage({ severity: 'warn', detail: `Item already selected: ${item.name}`, life: environment.errorElapsedTime });
        }
        return returnedNode;
    }

    removeItem(item: any, node: TreeNodeMeddraLevelItem) {
        this.children = this.children!.filter((child) => child.data.model.code !== item.code);
    }

    createChildren(): void {
    }

    getCriteriaFields() { }

    getPlaceHolderTemplate(): string{
        return "Search MedDRA...";
    }

    getPlaceHolderToolTipTemplate(): string{
        return this.getPlaceHolderTemplate() + " (Type any character and press [ENTER] to execute the search)";
    }

}


